export const KEY_TYPES = {
  CARD: 'KEY_CARD',
  REMOTE: 'KEY_REMOTE',
  KEY: 'KEY_KEY',
};
